import { render, staticRenderFns } from "./DelegacionesNewOrEdit.vue?vue&type=template&id=dac64c3a&scoped=true&"
import script from "./DelegacionesNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./DelegacionesNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./DelegacionesNewOrEdit.vue?vue&type=style&index=0&id=dac64c3a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac64c3a",
  null
  
)

export default component.exports